// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Risks dashboard (ported from ai_risk_control) */
.risks-root {
  min-height: 100%;
}

@keyframes skeleton-shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

.skeleton-bone {
  position: relative;
  overflow: hidden;
  background-color: rgb(226 232 240 / 0.95);
}

.dark .skeleton-bone {
  background-color: rgb(30 41 59 / 0.9);
}

.skeleton-bone::after {
  content: '';
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent 0%, rgb(148 163 184 / 0.28) 50%, transparent 100%);
  animation: skeleton-shimmer 1.5s ease-in-out infinite;
}

.dark .skeleton-bone::after {
  background: linear-gradient(90deg, transparent 0%, rgb(148 163 184 / 0.14) 50%, transparent 100%);
}

@media (prefers-reduced-motion: reduce) {
  .skeleton-bone::after {
    animation: none;
    transform: none;
    background: rgb(148 163 184 / 0.16);
  }
  .dark .skeleton-bone::after {
    background: rgb(148 163 184 / 0.08);
  }
}

.content-reveal {
  animation: content-reveal 180ms ease-out;
}

@keyframes content-reveal {
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: translateY(0); }
}
`, "",{"version":3,"sources":["webpack://./src/features/risks/styles/risks.css"],"names":[],"mappings":";AACA,kDAAkD;AAClD;EACE,gBAAgB;AAClB;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,4BAA4B;EAC5B,iGAAiG;EACjG,qDAAqD;AACvD;;AAEA;EACE,iGAAiG;AACnG;;AAEA;EACE;IACE,eAAe;IACf,eAAe;IACf,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C","sourcesContent":["\n/* Risks dashboard (ported from ai_risk_control) */\n.risks-root {\n  min-height: 100%;\n}\n\n@keyframes skeleton-shimmer {\n  0% { transform: translateX(-100%); }\n  100% { transform: translateX(100%); }\n}\n\n.skeleton-bone {\n  position: relative;\n  overflow: hidden;\n  background-color: rgb(226 232 240 / 0.95);\n}\n\n.dark .skeleton-bone {\n  background-color: rgb(30 41 59 / 0.9);\n}\n\n.skeleton-bone::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  transform: translateX(-100%);\n  background: linear-gradient(90deg, transparent 0%, rgb(148 163 184 / 0.28) 50%, transparent 100%);\n  animation: skeleton-shimmer 1.5s ease-in-out infinite;\n}\n\n.dark .skeleton-bone::after {\n  background: linear-gradient(90deg, transparent 0%, rgb(148 163 184 / 0.14) 50%, transparent 100%);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .skeleton-bone::after {\n    animation: none;\n    transform: none;\n    background: rgb(148 163 184 / 0.16);\n  }\n  .dark .skeleton-bone::after {\n    background: rgb(148 163 184 / 0.08);\n  }\n}\n\n.content-reveal {\n  animation: content-reveal 180ms ease-out;\n}\n\n@keyframes content-reveal {\n  from { opacity: 0; transform: translateY(4px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
